import script from "./_Admin.vue?vue&type=script&lang=js"
export * from "./_Admin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__